import { FC } from "react";
import { useParams } from "react-router-dom";

import { Card } from "../../../../../../../../components/card/Card";
import { LottieLoading } from "../../../../../../../../components/graphics/LottieLoading";
import { getLinkedFirm } from "../../../../../../../../sessionStorage/sessionStorage";
import { useGetOrgContactQuery } from "../../../../../../../../slices/ContactsSlice";
import { OrganizationInfo } from "./OrganizationInfo";

export const OrganizationInfoView: FC = () => {
  const { organizationId } = useParams();

  const { data: organization, isLoading } = useGetOrgContactQuery({
    id: organizationId || "",
    orgId: getLinkedFirm()?.orgId || "",
  });

  return organization ? (
    isLoading ? (
      <Card extraClasses={"overflow-hidden"}>
        <div className={"px-6 py-4"}>
          <div className={"mb-4 flex justify-between"}>
            <div className={"text-[17px] font-extrabold text-[#1F2433]"}>
              Contact Info
            </div>
          </div>
          <div>
            <LottieLoading />
          </div>
        </div>
      </Card>
    ) : (
      <OrganizationInfo />
    )
  ) : (
    <Card extraClasses={"overflow-hidden"}>
      <div className={"px-6 py-4"}>
        <div className={"mb-4 flex justify-between"}>
          <div className={"text-[17px] font-extrabold text-[#1F2433]"}>
            Contact Info
          </div>
        </div>
      </div>
    </Card>
  );
};
